import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoschUiButtonTypeEnum } from './bosch-ui-button.model';
import { BehaviorSubject } from 'rxjs';
import { BoschUiIconComponent } from '../bosch-ui-icon/bosch-ui-icon.component';
import { BoschUiIconNames } from '../bosch-ui-icon/bosch-ui-icon.constants';

@Component({
  selector: 'bosch-ui-button',
  standalone: true,
  imports: [CommonModule, BoschUiIconComponent],
  templateUrl: './bosch-ui-button.component.html',
  styleUrls: ['./bosch-ui-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiButtonComponent implements AfterViewInit {
  @Input() type: BoschUiButtonTypeEnum = BoschUiButtonTypeEnum.Primary;
  @Input() fixed = false;
  @Input() disabled = false;
  protected readonly state$ = new BehaviorSubject({
    hasTextContent: true,
    hasIcon: false,
  });
  protected readonly buttonType = BoschUiButtonTypeEnum;
  protected readonly closeIcon = BoschUiIconNames.Close;
  protected readonly buttonTypeClassesMap: { [key in BoschUiButtonTypeEnum]: string } = {
    [BoschUiButtonTypeEnum.Primary]: 'a-button--primary',
    [BoschUiButtonTypeEnum.Secondary]: 'a-button--secondary',
    [BoschUiButtonTypeEnum.Tertiary]: 'a-button--tertiary',
    [BoschUiButtonTypeEnum.Integrated]: 'a-button--integrated',
    [BoschUiButtonTypeEnum.Close]: 'a-button--integrated',
  };

  constructor(private element: ElementRef) {}

  ngAfterViewInit(): void {
    this.state$.next({
      hasTextContent: !!this.element.nativeElement.outerText,
      hasIcon: !!this.element.nativeElement.querySelector('[button-icon]'),
    });
  }
}
